"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrors = void 0;
const tslib_1 = require("tslib");
const enum_1 = tslib_1.__importDefault(require("../structures/helpers/enum"));
var ValidationErrors;
(function (ValidationErrors) {
    ValidationErrors[ValidationErrors["None"] = 0] = "None";
    ValidationErrors[ValidationErrors["ShouldBeNonEmpty"] = 1] = "ShouldBeNonEmpty";
    ValidationErrors[ValidationErrors["ShouldBeEqualTo"] = 2] = "ShouldBeEqualTo";
    ValidationErrors[ValidationErrors["InvalidNameFormat"] = 3] = "InvalidNameFormat";
    ValidationErrors[ValidationErrors["InvalidEmailFormat"] = 4] = "InvalidEmailFormat";
    ValidationErrors[ValidationErrors["InvalidPasswordFormat"] = 5] = "InvalidPasswordFormat";
    ValidationErrors[ValidationErrors["OnlyEnglishLetters"] = 6] = "OnlyEnglishLetters";
    ValidationErrors[ValidationErrors["InvalidPhoneFormat"] = 7] = "InvalidPhoneFormat";
    ValidationErrors[ValidationErrors["InvalidCreditCardFormat"] = 8] = "InvalidCreditCardFormat";
    ValidationErrors[ValidationErrors["InvalidCreditCardExpiryDateFormat"] = 9] = "InvalidCreditCardExpiryDateFormat";
    ValidationErrors[ValidationErrors["InvalidCreditCardCvvFormat"] = 10] = "InvalidCreditCardCvvFormat";
    ValidationErrors[ValidationErrors["OnlyDigit"] = 11] = "OnlyDigit";
    ValidationErrors[ValidationErrors["EmailIsInUse"] = 12] = "EmailIsInUse";
    ValidationErrors[ValidationErrors["FirstName"] = 13] = "FirstName";
    ValidationErrors[ValidationErrors["LastName"] = 14] = "LastName";
    ValidationErrors[ValidationErrors["Website"] = 15] = "Website";
    ValidationErrors[ValidationErrors["Linkedin"] = 16] = "Linkedin";
})(ValidationErrors = exports.ValidationErrors || (exports.ValidationErrors = {}));
(function (ValidationErrors) {
    ValidationErrors.Helper = new enum_1.default(ValidationErrors);
})(ValidationErrors = exports.ValidationErrors || (exports.ValidationErrors = {}));
//# sourceMappingURL=ValidationErrors.js.map